import React from 'react'

export const PortfolioInvestedBubbleChart: React.FC = () => {
  return (
    <div className="absolute right-0 top-0 h-[124px] w-[185px] overflow-hidden">
      <div className="absolute left-[38px] top-[8px] h-[108px] w-[108px] rounded-full bg-[rgba(197,204,159,0.28)]" />

      <div className="absolute left-[44px] top-[40px] flex h-[39px] w-[39px] items-center justify-center rounded-full bg-[#c8ed03]">
        <span className="font-['Plus_Jakarta_Sans'] text-[13px] font-medium leading-[17px] text-[#2e2e2e]">109</span>
      </div>

      <div className="absolute left-[75px] top-[22px] flex h-[67px] w-[67px] items-center justify-center rounded-full bg-[rgba(45,41,35,0.72)]">
        <span className="font-['Plus_Jakarta_Sans'] text-[15px] font-semibold leading-[20px] text-white">320</span>
      </div>

      <div className="absolute left-[80px] top-[76px] flex h-[26px] w-[26px] items-center justify-center rounded-full bg-[#2d2923]">
        <span className="font-['Plus_Jakarta_Sans'] text-[8px] font-semibold leading-[12px] text-white">45</span>
      </div>
    </div>
  )
}

export default PortfolioInvestedBubbleChart
